import React, { useEffect, useRef, useState } from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import i18n from '@i18next/i18n';
import PageRange from '../range';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import DownloadManager from '@src/slide/application/service/download-manager';
import { DialogProps, QUICK_TOOL_AID_FEATURE } from '..';
import { showVipLinktext } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import ImageUrl from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-url';
import ImageQuickLookManager from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-quick-look-manager';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { isLateXModel } from '@src/slide/application/service/addon/utils';
import { isUiModelIsAttachment } from '@src/slide/domain/ui-model/elements/element-judge';

const apprec = 'batdownloadpic';

type IExportPicture = React.FC<DialogProps>;
const ExportPictureDialog: IExportPicture = (props: DialogProps) => {
    const {
        visible, onClose, onOk, position, services,
    } = props;
    const [pictureList, setPictureList] = useState<IPictureModel[]>([]);
    const [slideList, setSlideList] = useState<ISlideModel[]>();


    const getImagesInfo = () => pictureList.map((item, index) => {
        const name = `${i18n.t('图片')}-${index + 1}`;
        let url = item.props.src;
        if (ImageUrl.isBlobUrl(url)) {
            const ImageResource = ImageQuickLookManager.getInstance().getResourceByUrl(url);
            const cdnUrl = ImageResource?.getCdnUrl();
            if (cdnUrl) {
                url = cdnUrl;
            }
        }
        return {
            name,
            url,
        };
    });

    const handleOk = async () => {
        if (!onOk(apprec, i18n.t('批量图片下载')) || !slideList) {
            return;
        }
        await Promise.all(slideList.map(async (slide) => {
            !slide.childrenConverted && await slide.startConvertChildrenTask(TaskPriority.HIGH);
        }));
        const imagesInfo = getImagesInfo();
        DownloadManager.downloadMutiImageToZip(imagesInfo);
        onClose();
    };

    const getModelPictureList = (model: IBaseModel, tempPictureList: any[]) => {
        if (model.type === UIModelType.GROUP) {
            model.children.forEach((child) => {
                getModelPictureList(child, tempPictureList);
            });
        }
        if (model.type === UIModelType.IMAGE) {
            if (isUiModelIsAttachment(model as IElementBaseModel) || isLateXModel(model as IElementBaseModel)) {
                return;
            }
            tempPictureList.push(model);
        }
    };

    const getPictureList = () => {
        const tempPictureList = [];
        slideList?.forEach((slide) => {
            slide.children.forEach((child) => {
                getModelPictureList(child, tempPictureList);
            });
        });
        setPictureList(tempPictureList);
    };

    useEffect(() => {
        getPictureList();
    }, [slideList]);

    const vipLinkRef = useRef(null);
    useEffect(() => {
        showVipLinktext({
            ref: vipLinkRef.current,
            name: i18n.t('批量图片下载'),
            feature: QUICK_TOOL_AID_FEATURE,
            position,
            apprec,
            anchor: 'PPT-TOOLS',
        });
    }, [vipLinkRef.current]);

    return (
        <Modal
            title={i18n.t('批量图片下载')}
            visible={visible}
            onClose={onClose}
            onCancel={onClose}
            className={'muti-export-pic-dialog'}
            onOk={handleOk}
            okDisabled={!pictureList.length}
        >
            <div style={{ width: '100%', marginBottom: '10px' }} ref={vipLinkRef}></div>
            <span style={{ marginBottom: '20px', fontSize: '14px', color: 'rgba(0, 0, 0, 0.48)' }}>
                {i18n.t('共选择{0}个图片', { 0: pictureList.length })}
            </span>
            <PageRange
                needGetSelectModels={true}
                onCheckStateChange={list => setSlideList(list)}
                services={{
                    masterLayoutEditService: services.masterLayoutEditService,
                    selectionService: services.selectionService,
                }}>
            </PageRange>
        </Modal>
    );
};

export default ExportPictureDialog;
